import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    Inject,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '../../services/api-service/api.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import heic2any from "heic2any";
@Component({
    selector: 'app-document-preview',
    templateUrl: './document-preview.component.html',
    styleUrls: ['./document-preview.component.scss'],
})
export class DocumentPreviewComponent
implements OnInit, AfterViewInit, OnDestroy
{
    imageRegex = /\.(gif|jpe?g|tiff?jpg|jpeg|png|gif|JPG|JPEG|PNG|GIF|heic)$/;
    documentRegex = /\.(docx|doc|pptx|ppt|csv)$/;
    excelRegex = /\.(xlsx|xlx|xls)$/;
    videoPreview = /\.(mp4)$/;
    pdfRegex = /\.(pdf)$/;
    previewMatadata: any = {};
    documentPreviewTypes: any = {
        image: false,
        document: false,
        video: false,
        notpriview: false,
        pdf: false,
        excel:false
    };
    previewUrlheic:any

    constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DocumentPreviewComponent>,
    public sanitizer: DomSanitizer,
    public apiService: ApiService,
    private cd: ChangeDetectorRef
    ) {
        this.handleCheckDocumentTypes();
        if (this.documentPreviewTypes.image || this.documentPreviewTypes.video) {
            this.previewMatadata = { ...this.data };
            if(this.previewMatadata?.url?.includes('heic')){
                setTimeout(() => {
                    this.fetchHEICFile();
                }, 100);
            }
        }
        if (this.documentPreviewTypes.pdf) {
            this.previewMatadata = { ...this.data };
            window.open(this.previewMatadata.url, '_blank');
            this.dialogRef.close();
        }
        if (this.documentPreviewTypes.excel) {
            this.previewMatadata = { ...this.data, docurl:this.sanitizeUrl(this.data.url)};
            // window.open(this.previewMatadata.url, '_blank');
            // this.dialogRef.close();
        }
        if (this.documentPreviewTypes.document) {
            this.previewMatadata = { ...this.data };
            this.apiService.showLoading();
        }
    }

    async fetchHEICFile() {
        try {
            this.apiService.showLoading();
          const response = await fetch(this.previewMatadata?.url);
          const blob = await response.blob();
    
          const converted = await heic2any({
            blob,
            toType: "image/jpeg",
            quality: 0.9,
          });
          const resultBlob = Array.isArray(converted) ? converted[0] : converted;
          // Mark blob URL as safe
          const objectUrl = URL.createObjectURL(resultBlob as Blob);
          this.previewMatadata.url = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
          this.apiService.hideLoading();
        } catch (error) {
          console.error("HEIC conversion failed:", error);
          this.apiService.hideLoading();
        }
      }
    

    ngOnInit(): void {
        // Intialize the component
        // setTimeout(() => {
        //     this.fetchHEICFile();
        // }, 100);
    }

    sanitizeUrl(url: string): SafeResourceUrl {
        const encodedUrl = encodeURIComponent(url);
        const officeViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodedUrl}`;
        return this.sanitizer.bypassSecurityTrustResourceUrl(officeViewerUrl);
    }

    handleCheckDocumentTypes() {
        if (this.imageRegex.test(this.data.docType)) {
            this.documentPreviewTypes.image = true;
        } else if (this.documentRegex.test(this.data.docType)) {
            this.documentPreviewTypes.document = true;
        } else if (this.videoPreview.test(this.data.docType)) {
            this.documentPreviewTypes.video = true;
        } else if (this.pdfRegex.test(this.data.docType)) {
            this.documentPreviewTypes.pdf = true;
        }else if (this.excelRegex.test(this.data.docType)) {
            this.documentPreviewTypes.excel = true;
        }else {
            this.documentPreviewTypes.notpriview = true;
        }
    }

    ngAfterViewInit(): void {
        // After intialize the component
    }

    handelClosedDialogBox() {
        this.dialogRef.close();
    }
    ngOnDestroy() {
        if (this.previewMatadata?.url) {
            URL.revokeObjectURL(this.previewMatadata?.url as string);
          }
        this.previewMatadata.length = 0;
    }
    documentLoaded(): void {
        this.apiService.hideLoading();
    }
}